import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import publishCourseImg from "./publish.svg"
import { Button, NamedLink } from '../../../components';

import css from './SectionFreeCreateProfile.module.css';

const SectionFreeCreateProfile = props => {
  const { handleGetStarted, currentUser, isTeacher, content } = props;

  return (
    <div className={css.root}>
      <div className={css.contentContainer}>
        <div className={css.info}>
          <h2 className={css.title}>
            {content?.freeTitle ?
              content.freeTitle :
              <FormattedMessage id="SectionFreeCreateProfile.listJobTitle" />
            }
          </h2>
          <h3 className={css.subtitle}>
            {content?.freeDescription ?
              content.freeDescription :
              <FormattedMessage id="OnlineTeachersForHirePage.freeCreateProfileSubtitle" />
            }
          </h3>

          {currentUser && !isTeacher && (
            <NamedLink
              name="NewJobPage"
              className={css.button}
            >
              <FormattedMessage id="SectionOnlineTeachersForHire.button" />
            </NamedLink>
          )}

          {!currentUser && (
            <>
              <div className={css.emailContainer}>
                {/*<input*/}
                {/*  onChange={() => setEmail(inputRef?.current?.value)}*/}
                {/*  ref={inputRef}*/}
                {/*  className={css.emailInput}*/}
                {/*  type="email"*/}
                {/*  placeholder={intl.formatMessage({ id: 'OnlineTeachingJobsPage.emailPlaceholder' })}*/}
                {/*/>*/}

                <Button className={css.button} onClick={handleGetStarted}>
                  <FormattedMessage id="SectionOnlineTeachersForHire.button" />
                </Button>
              </div>

              {/*<div className={css.socialButtonsWrapper}>*/}
              {/*  <GoogleAuthButton intl={intl} location={location} />*/}
              {/*  <FacebookAuthButton intl={intl} location={location} />*/}
              {/*</div>*/}

            </>
          )}

        </div>
        <div className={css.imageContainer}>
          <img src={publishCourseImg} className={css.image} />
        </div>

      </div>
    </div>
  )
}

export default SectionFreeCreateProfile;
